import {useContext, useEffect} from "react";
import {Form} from "antd";
import {SGeneralForms, SFormUploadImage} from "shj-components";
import {isEmpty} from "lodash-es";
import dayjs from "dayjs";

import {formatRelativeUploadData} from "@/utils/file.ts";
import measureContext from "./measureContext.ts";
import styles from "./index.module.less";
import config from "@/config";
import {measureUpdateClueDtl} from "@/services/crmTool.ts";
import {useFileUrlPrefix} from "shj-utils";
import {beforeUpload} from "@/pages/roomMeasurementTools/roomMeasurementManage/utils.ts";

export const Step2 = (props) => {
  const fileUrlPrefix = useFileUrlPrefix()
  const {detailInfo, setLoading} = useContext(measureContext)
  const {dictionaryData} = props;
  const [form] = Form.useForm()

  useEffect(() => {
    if (!isEmpty(detailInfo)) {
      console.log(detailInfo)
      form.setFieldsValue({
        ...detailInfo,
        childAge: detailInfo.childAge ? detailInfo.childAge.split(',') : undefined,
        childGender: detailInfo.childGender ? detailInfo.childGender.split(',') : undefined,
        pets: detailInfo.pets ? detailInfo.pets.split(',') : undefined,
        actualMeasureTime: detailInfo.actualMeasureTime ? dayjs(detailInfo.actualMeasureTime) : null,
        planCompleteTime: detailInfo.planCompleteTime ? dayjs(detailInfo.planCompleteTime) : null,
        communicateTime: detailInfo.communicateTime ? dayjs(detailInfo.communicateTime) : null,
        renovationDemand: detailInfo.renovationDemand ? detailInfo.renovationDemand.split(',') : undefined,
        housePhotoUrls: detailInfo.housePhotoUrls?.filter(item => item)?.map(item => (item.url ? item : {filePath: item, url: fileUrlPrefix + item}))
      })
    }
  }, [detailInfo]);

  const handleValues = (values) => {
    return {
      measureRoomId: detailInfo.measureRoomId,
      ...values,
      childAge: values.childAge ? values.childAge.join(',') : undefined,
      childGender: values.childGender ? values.childGender.join(',') : undefined,
      pets: values.pets ? values.pets.join(',') : undefined,
      renovationDemand: values.renovationDemand ? values.renovationDemand.join(',') : undefined,
      actualMeasureTime: values.actualMeasureTime ? dayjs(values.actualMeasureTime).format('YYYY-MM-DD HH:mm:ss') : undefined,
      planCompleteTime: values.planCompleteTime ? dayjs(values.planCompleteTime).format('YYYY-MM-DD HH:mm:ss') : undefined,
      communicateTime: values.communicateTime ? dayjs(values.communicateTime).format('YYYY-MM-DD HH:mm:ss') : undefined,
      housePhotoUrls: values.housePhotoUrls ? formatRelativeUploadData(values.housePhotoUrls).map(item => item.filePath) : undefined,
    }
  }

  const onSubmit = () => {
    return new Promise((resolve, reject) => {
      form.validateFields().then(values => {
        setLoading(true)
        const newValues = handleValues(values)
        measureUpdateClueDtl(newValues).then(() => {
          resolve(newValues)
        }).catch(reject).finally(() => setLoading(false))
      }).catch(reject)
    })
  }

  const onSaveCache = () => {
    const formValues = form.getFieldsValue()
    return Promise.resolve(handleValues(formValues))
  }

  if (props.stepRef) {
    props.stepRef.step2 = {onSubmit, onSaveCache}
  }

  return <div className={styles.stepFormBox}>
    <SGeneralForms
        formConfig={{form}}
        layout={'vertical'}
        configs={[{
          formItem: [
            {
              spanCol: 8,
              label: '需求标签',
              name: 'bizTypes',
              required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'select',
              comConfig: {
                mode: 'multiple',
                options: dictionaryData['bizTypes'],
                fieldNames: {label: 'description', value: 'key'}
              }
            },
            {
              spanCol: 8,
              label: '装修风格',
              name: 'designStyleCode',
               required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'select',
              comConfig: {
                options: dictionaryData['designStyle'],
                fieldNames: {label: 'description', value: 'key'}
              }
            },
            {
              spanCol: 8,
              label: '常住人口',
              name: 'permanentResidents',
               required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'select',
              comConfig: {
                options: dictionaryData['permanentResidents'],
                fieldNames: {label: 'description', value: 'key'}
              }
            },
            {
              spanCol: 8,
              label: '孩子性别',
              name: 'childGender',
              type: 'select',
              comConfig: {
                mode: 'multiple',
                options: [
                  {label: '男', value: '男'},
                  {label: '女', value: '女'}
                ],
              }
            },
            {
              spanCol: 8,
              label: '孩子年龄',
              name: 'childAge',
              type: 'select',
              comConfig: {
                mode: 'multiple',
                options: dictionaryData['ageRange'],
                fieldNames: {label: 'label', value: 'priKey'}
              }
            },
            {
              spanCol: 8,
              label: '宠物',
              name: 'pets',
              type: 'select',
              comConfig: {
                mode: 'multiple',
                options: dictionaryData['pets'],
                fieldNames: {label: 'label', value: 'priKey'}
              }
            },
            {
              spanCol: 8,
              label: '宠物备注',
              name: 'petsOther',
              isDeps: true,
              deps: (form) => form.getFieldValue('pets')?.includes('pets_other'),
              comConfig: {
               maxLength: 200,
                showCount: true,
              }
            },
            {
              spanCol: 8,
              label: '户型改造需求',
              name: 'renovationDemand',
              required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'select',
              comConfig: {
                mode: 'multiple',
                options: dictionaryData['houseDemand'],
                fieldNames: {label: 'label', value: 'priKey'}
              }
            },
            {
              spanCol: 8,
              label: '户型改造需求备注',
              name: 'renovationDemandOther',
              isDeps: true,
              deps: (form) => form.getFieldValue('renovationDemand')?.includes("house_renovation_demand_other"),
              comConfig: {
                maxLength: 200,
                showCount: true,
              }
            },
            {
              spanCol: 8,
              label: '量房时间',
              name: 'actualMeasureTime',
               required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'dateTime',
              comConfig: {
                disabledDate: (current) => current && current < dayjs().subtract(1, 'day')
              }
            },
            {
              spanCol: 8,
              label: '方案完成时间',
              name: 'planCompleteTime',
               required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'dateTime',
              comConfig: {
                disabledDate: (current) => current && current < dayjs().subtract(1, 'day')
              }
            },
            {
              spanCol: 8,
              label: '见面沟通时间',
              name: 'communicateTime',
               required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'dateTime',
              comConfig: {
                disabledDate: (current) => current && current < dayjs().subtract(1, 'day')
              }
            },
            {
              spanCol: 24,
              label: '房屋现场照片',
              name: 'housePhotoUrls',
               required: true,
              rules: [{required: true, message: '不能为空'}],
              children: (<SFormUploadImage
                  url={config.api + '/file-web/file/upload'}
                  // setFileUrl={formatRelativeUploadData}
                  maxCount={20} limit={20} multiple={true}
                  beforeUpload={(file) => beforeUpload(file, '.bpm,.jpg,.jpeg,.png')}
                  accept={'.bpm,.jpg,.jpeg,.png'}
              />)
            },
          ]
        }]}/>
  </div>
}